<script>
	import PainelBox from '../templates/PainelBox.svelte';
	import Listagem from '../Listagem.svelte';
	import { TiposObjetosListagem } from '../../utils';
	import CartaoRetangulo from '../../componentes/cartoes/CartaoRetangulo.svelte';
</script>

<PainelBox 
	largura="12" 
	deslocamento="0"
	titulo="Listagem de Afirmações">
	
	<Listagem 
		chaveLSCache="AVAL_LISTAGEM_AFIRMACOES_CACHE_PG" 
		endpointRecurso="afirmacoes" 
		tipoObjeto={TiposObjetosListagem.AFIRMACAO} 
		componenteCartao={CartaoRetangulo}
		flexWrapFlagGrade={false}
		on:routeEvent />
</PainelBox>
